import fetchPost from '@/api/http.js'

export default {
    actions: {
        getAddrInformationCfg({}, data) {
            return fetchPost('/saas/baseInfo/addrInformationCfg/queryPage', data)
        },  deleteAddrInformationCfg({}, data) {
            return fetchPost('/saas/baseInfo/addrInformationCfg/delete', data)
        },  deleteAllAddrInformationCfg({}, data) {
            return fetchPost('/saas/baseInfo/addrInformationCfg/deleteBatch', data)
        },  queryCitys({}, data) {
            return fetchPost('/saas/baseInfo/addrInformationCfg/queryCitys', data)
        },
    }
}
